import { Injectable } from '@angular/core';
import { IFilterListService } from './ifilter-list.service';
import { Photographer } from '../../models/common/photographer.models';
import { map } from 'rxjs';
import { Selectable } from '../models/types/selectable.type';
import { GetQuery } from '../../models/shared/enums/get-query.enum';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WrapperResultGraphQL } from '../../models/shared/types/wrapper-result-graphql.type';

@Injectable({
  providedIn: 'root'
})
export class PhotographerFilterService extends IFilterListService<Photographer> {

  search(searchText: string, variables): void {
    this.graphQlService.getData<Photographer>(GetQuery.GET_PHOTOGRAPHERS, { search: searchText, companyId: Number(this.appService.companyId), paginationPage: variables.page, paginationSize: variables.size, statusIds: [] })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map(res => res['data']['photographers'])
      )
      .subscribe({
        next: (res: WrapperResultGraphQL<Photographer>) => {
          const datasource: Array<Selectable<Photographer>> = res.nodes.map(el => ({ ...el, displayId: el.personId!, displayName: el.fullName!, disabled: false, selected: false }));
          this.datasource.next(datasource);
        }
      })
  }
}
